import { render, staticRenderFns } from "./RegisterDialog.vue?vue&type=template&id=c01719ca&scoped=true&"
import script from "./RegisterDialog.vue?vue&type=script&lang=js&"
export * from "./RegisterDialog.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDialog.vue?vue&type=style&index=0&id=c01719ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01719ca",
  null
  
)

export default component.exports